import useRequest from '@/websdk/utils/request';
import { useEffect, useState } from 'react';
import specialValues from '@/constant/special_values';

export default (function (id) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '',
    name: 'craftManageDetailGet',
    method: 'GET',
  });
  useEffect(() => {
    if (id) {
      let url = `/api/produce-crafts/${id}/params/detail`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const [newDatas, setNewDatas] = useState([]);
  useEffect(() => {
    if (data && data.length !== 0) {
      let newDatas_ = [];
      data.forEach(cdata => {
        let newData_ = JSON.parse(JSON.stringify(cdata));
        // 资料段数处理
        if (newData_.name === 'clp_open' || newData_.name === 'inj' || newData_.name === 'hold') {
          newData_.rows.forEach(row => {
            if (row === 'SEGNUMBER') {
              let seg = newData_.data[newData_.data.length - 1][0].value;

              newData_.rows.splice(-1, 1);
              newData_.data.splice(-1, 1);
              newData_.param_ids.splice(-1, 1);
              if (seg && 0 < parseInt(seg) < 7) {
                newData_.data.forEach(d => {
                  d.forEach((dd, i) => {
                    if (i < newData_.columns.length - seg) {
                      dd.value = '';
                    }
                  });
                });
              }
            }
          });
        }
        if (newData_.name === 'clp_cls' || newData_.name === 'charge') {
          newData_.rows.forEach(row => {
            if (row === 'SEGNUMBER') {
              let seg = newData_.data[newData_.data.length - 1][0].value;

              newData_.rows.splice(-1, 1);
              newData_.data.splice(-1, 1);
              newData_.param_ids.splice(-1, 1);
              if (seg && 0 < parseInt(seg) < 7) {
                newData_.data.forEach(d => {
                  d.forEach((dd, i) => {
                    if (i >= seg) {
                      dd.value = '';
                    }
                  });
                });
              }
            }
          });
        }
        newData_.values = newData_.data.map(arr => {
          return arr.map(param => {
            if (param.value) {
              const value = param.value.toString().replace('.', '');
              if (specialValues.indexOf(value) !== -1) {
                param.value = '';
              }
            }
            return param.value;
          });
        });
        newDatas_.push(newData_);
      });
      setNewDatas(newDatas_);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isRequestSuccessed]);

  return [isRequestSuccessed, newDatas, exec];
});
